/**
 * Multi-Level Mega Menu JavaScript
 * Handles mobile interactions for 3-level navigation
 */

(function() {
  'use strict';

  // Check if mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }

  // Initialize mega menu for mobile
  function initMegaMenu() {
    // Use event delegation for better reliability
    document.addEventListener('click', function(e) {
      // Only handle on mobile
      if (!isMobile()) return;

      // Check if clicked on a grandchild parent link or its children
      const link = e.target.closest('.site-nav--has-grandchild > a');
      if (!link) return;

      const parentLi = link.closest('.site-nav--has-grandchild');
      if (!parentLi) return;

      // Toggle expanded state
      const isExpanded = parentLi.classList.contains('mobile-expanded') ||
                         parentLi.classList.contains('show-dropdown');

      if (isExpanded) {
        parentLi.classList.remove('mobile-expanded');
        parentLi.classList.remove('show-dropdown');
      } else {
        // Close other expanded third-level menus
        document.querySelectorAll('.site-nav--has-grandchild.mobile-expanded, .site-nav--has-grandchild.show-dropdown').forEach(function(item) {
          if (item !== parentLi) {
            item.classList.remove('mobile-expanded');
            item.classList.remove('show-dropdown');
          }
        });

        parentLi.classList.add('mobile-expanded');
        parentLi.classList.add('show-dropdown');
      }

      // Prevent default link behavior
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // Also handle touch events for better mobile response
    document.addEventListener('touchend', function(e) {
      if (!isMobile()) return;

      const link = e.target.closest('.site-nav--has-grandchild > a');
      if (!link) return;

      // Let the click handler deal with it, but mark as touched
      link.dataset.touched = 'true';
    }, { passive: true });
  }

  // Initialize immediately
  initMegaMenu();

  // Log for debugging
  console.log('Mega Menu JS loaded - mobile breakpoint: 768px');
})();
